<template>
  <el-dialog title='新增刊例' :visible.sync='dialogFormVisible' width='clamp(1200px, 80%, 1440px)' center>
    <div class='theme-border' style='margin: auto;text-align: center'>
      <!--      <json-display :value='formData'></json-display>-->
      <!--          刊例基本信息-->
      <el-form :inline='true' :model='formData' :rules='rules' ref='formData' class='padding-effect'
               style='width: 100%;text-align: left'>
        <el-form-item label='归属组织' prop='org_name'>
          <el-select
              v-model='formData.org_name'
              @change='handleOrgName'
              filterable
              allow-create
              default-first-option
              style='width: 160px'
              placeholder='归属组织,可自建(20个字符)' clearable>
            <el-option
                v-for='item in options'
                :key='item.value'
                :label='item.label'
                :value='item.value'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='归属月份' prop='date_month'>
          <el-date-picker
              @change='handleDateMonth'
              :clearable='true'
              :disabled='!!formData.id'
              format='yyyy 年 MM 月'
              placeholder='刊例月份'
              style='width: 160px'
              type='month'
              v-model='formData.date_month'
              value-format='yyyy-MM'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='有效期' prop='date_range'>
          <el-date-picker
              @change='handlerange'
              end-placeholder='结束日期'
              range-separator='至'
              start-placeholder='开始日期'
              style='width: 240px'
              type='daterange'
              v-model='formData.date_range' value-format='yyyy-MM-dd'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='截止日期' prop='deadline'>
          <el-date-picker
              :clearable='true'
              @change='handldeadline'
              format='yyyy年MM月dd日'
              placeholder='提报截止日期'
              type='date'
              v-model='formData.deadline' value-format='yyyy-MM-dd' style='width: 160px'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='刊例标题'>
          <el-input
              v-model='formData.title' style='width: 300px' placeholder='刊例标题，默认格式：月份+组织+KOL刊例' clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model='formData.adopt_cover'>沿用上期-刊例封面</el-checkbox>
        </el-form-item>
      </el-form>
      <div class='padding-effect'
           style='display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: flex-start;align-items: flex-start;gap: 5px'>
        <div style='flex: 1'>
          <el-table :data='gridData' height='450' @selection-change='handleSelection' border>
            <el-table-column
                align='center'
                header-align='center'
                type='selection'
                width='55'>
            </el-table-column>
            <el-table-column property='name' label='刊例类型' width='100' align='center'></el-table-column>
          </el-table>
        </div>
        <div style='flex: 6' class='theme-border padding-effect'>
          <div>
            <span style='font-size: 1.1rem;font-weight: bolder'>本期刊例：{{ dataList.length }}</span>
          </div>
          <el-table :data='dataList' :highlight-current-row='true' :stripe='true'
                    border
                    ref='elTable'
                    element-loading-spinner='el-icon-loading'
                    element-loading-text='加载中……'
                    height='410'
          >
            <el-table-column label='组织' width='100' prop='org_name' align='center'></el-table-column>
            <el-table-column label='月份' width='100' prop='year' align='center'>
              <template slot-scope='{row}'>
                <span>{{ row.year }}年{{ row.month }}月</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='刊例类型' width='140' header-align='center'>
              <template slot-scope='{row}'>
                <div class=''>
                  <el-image :src='row.logo_url' :style='`width:100px;height:50px;`' fit='fill' :alt='row.logo_url'/>
                  <div class='sheet_title'>
                    <span>{{ row.sheet_title }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' width='220' align='center' header-align='center'
                             label='刊例标题'>
              <template slot-scope='{row}'>
                <el-link v-if='row.id' type='primary'>{{ row.title || '/' }}</el-link>
                <span v-else>{{ row.title }}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='有效期' width='160'>
              <template slot-scope='{row}'>
                <span>{{ row.validity_date }} ~ {{ row.expiry_date }}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='提报截止日期' width='120'>
              <template slot-scope='{row}'>
                <span>{{ row.deadline }}</span>
              </template>
            </el-table-column>
            <el-table-column label='沿用数据' width='120' prop='order' align='left'>
              <template slot-scope='{row}'>
                <div style='display: flex;justify-content: flex-start; align-items: flex-start;flex-direction: column'>
                  <el-checkbox-group v-model='row.adopt_options' size='mini'>
                    <el-checkbox label='same_notice'>合作须知</el-checkbox>
                    <el-checkbox label='same_tpl'>提报模板</el-checkbox>
                    <!--                    <el-checkbox label='same_record'>提报记录</el-checkbox>-->
                  </el-checkbox-group>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>
    <div slot='footer' style='text-align: center'>
      <el-button @click='dialogFormVisible = false' size='medium' round>取消</el-button>
      <el-button type='primary' @click='handleSubmit' size='medium' :disabled='loading' :loading='loading' round>确定
      </el-button>
    </div>
  </el-dialog>

</template>
<script>
import {clearAllValues, isObject} from '@/utils/utils'
import JsonDisplay from '@/components/display/JsonDisplay.vue'
import {appendPublication, createPublicationMonth} from '@/api/plc'

export default {
  name: 'PlcCreatePanel',
  components: {JsonDisplay},
  data() {
    return {
      id: null,
      formData: {
        title: '',
        org_name: '',
        date_month: null,
        year: null,
        month: null,
        date_range: [],
        deadline: null,
        adopt_cover: true//是否沿用上期封面数据
      },
      rules: {
        // title: {required: true, message: '公司必填'},
        org_name: {required: true, message: '组织必填'},
        date_month: {required: true, message: '月份必填'},
        date_range: {required: true, message: '有效期必填'},
        deadline: {required: true, message: '截止日期必填'}
      },
      options: [
        {
          value: '缇苏',
          label: '缇苏'
        },
        {
          value: '青澜',
          label: '青澜'
        }
      ],
      dataList: [],
      dialogFormVisible: false,
      loading: false,
      gridData: [],
      selection: [
        // {
        //   id: null,
        //   pm_id: null,
        //   org_name: '',
        //   platform_code: '',
        //   platform_name: '',
        //   sheet_title: '',
        //   logo_url: null,
        //   title: null,
        //   validity_date: null,
        //   expiry_date: null,
        //   deadline: null,
        //   adopt_options: ['same_notice', 'same_tpl'],//, 'same_record'
        // }
      ]
    }
  },
  methods: {
    show() {
      clearAllValues(this.formData)
      this.dataList = []
      this.selection = []
      this.loading = false
      this.dialogFormVisible = true
      //默认沿用上期封面
      this.formData.adopt_cover = true

      this.getJournalGridData()
    },
    handleOrgName() {
      this.dataList.forEach((item, index) => {
        this.dataList[index].org_name = this.formData.org_name
      })
      this.fixTableLayout()
    },
    handleDateMonth() {
      const dateArr = this.formData.date_month.split('-')
      this.formData.year = dateArr[0]
      this.formData.month = dateArr[1]
      this.formData.title = `${this.formData.year}年${this.formData.month}月${this.formData.org_name}KOL刊例`
      // 月份
      if (this.dataList) {
        this.dataList.forEach((item, index) => {
          this.dataList[index].year = dateArr[0]
          this.dataList[index].month = dateArr[1]
        })
        this.fixTableLayout()
      }
    },
    handlerange(val) {
      if (val && val.length === 2) {
        this.formData.validity_date = val[0]
        this.formData.expiry_date = val[1]
        //有效期
        if (this.dataList) {
          this.dataList.forEach((item, index) => {
            this.dataList[index].validity_date = this.formData.validity_date
            this.dataList[index].expiry_date = this.formData.expiry_date
          })
          this.fixTableLayout()
        }
      }
    },
    // 修复布局
    fixTableLayout() {
      // 确保在DOM更新后执行
      this.$nextTick(() => {
        const table = this.$refs.elTable
        if (table && table.doLayout) {
          table.doLayout() // 重新计算布局
        }
      })
    },
    handldeadline(val) {
      if (val && val.indexOf('-') > -1) {
        const arr = val.split('-')
        const date = new Date(arr[0], arr[1] - 1, arr[2])
        this.dataList.forEach((item, index) => {
          this.dataList[index].deadline = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        })
      }
    },
    async getJournalGridData() {
      // 获取最新平台信息
      const {list} = await this.$api.getJournalList({})
      this.gridData = list || []

    },
    handleSelection(rows) {

      this.dataList = rows.map(row => {

        return {
          id: null,
          pm_id: this.id,
          org_name: this.formData.org_name,
          year: this.formData.year,
          month: this.formData.month,
          platform_code: row.code,
          platform_name: row.name,
          sheet_title: `${row.name}KOL`,
          logo_url: row.logo_url,
          title: `${this.formData.year || '-'}年${this.formData.month || '-'}月${this.formData.org_name || ''}${row.name}KOL刊例`,
          validity_date: this.formData.validity_date,
          expiry_date: this.formData.expiry_date,
          deadline: this.formData.deadline,
          adopt_options: ['same_notice', 'same_tpl']
        }
      })
      this.selection = rows
    },
    //提交基础信息
    async formSubmit() {
      // console.log('this.formData', this.formData)
      const dateArr = this.formData.date_month.split('-')
      const postData = {
        org_name: this.formData.org_name,
        year: dateArr[0],
        month: dateArr[1],
        // title: this.journalTitle,
        title: this.formData.title,
        validity_date: this.formData.validity_date,
        expiry_date: this.formData.expiry_date,
        deadline: this.formData.deadline,
        adopt_cover: this.formData.adopt_cover
        // id: rowId || null
      }
      const data = await createPublicationMonth(postData)
      if (data && !isObject(data)) {
        this.msgSuccess('保存成功')
        this.id = data
        return data
      } else {
        this.msgSuccess('失败原因：' + data.msg || '未知')
        return null
      }
    },
    async handleAddRow(item, orderNumber) {
      // 发起请求
      const params = {
        pm_id: this.id,
        org_name: this.formData.org_name,
        year: this.formData.year,
        month: this.formData.month,
        title: item.title,
        platform_code: item.platform_code,
        sheet_title: `${item.sheet_title}`,
        validity_date: this.formData.validity_date,
        expiry_date: this.formData.expiry_date,
        deadline: this.formData.deadline,
        logo_url: item.logo_url,
        adopt_options: item.adopt_options,
        order: orderNumber + 1
      }

      const id = await appendPublication(params)
      if (id) {
        return id
      }
    },
    async onSubmit() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 2000)
      // 1) 提交刊例基本信息
      const id = await this.formSubmit()
      if (this.id && id) {
        // 2) 提交刊例的平台类型
        if (this.dataList && this.dataList.length > 0) {
          const fetchPromises = this.dataList.map((row, index) => {
            this.handleAddRow(row, index)
          })
          await Promise.all(fetchPromises)
              // eslint-disable-next-line no-unused-vars
              .then((_userDataArray) => {
                // console.log('所有数据:', _userDataArray)
                this.$notify.success('提交完毕')
                // console.log('------- Promise.all ----------')
              })
              .catch((error) => {
                console.error('某个请求失败:', error)
                this.loading = false
              })
        }

        // console.log('------- 刊例已创建 ----------')
        await this.$alert(`${this.formData.year}年${this.formData.month}月${this.formData.org_name}刊例创建完毕！`, '提示', {
          type: 'warning',
          confirmButtonText: '前往刊例详情',
          // eslint-disable-next-line no-unused-vars
          callback: action => {
            this.dialogFormVisible = false
            this.$emit('saved', {id: id})
          }
        })
      }


    },
    async handleSubmit() {

      this.$refs['formData'].validate(valid => {
        if (!valid) return
        this.onSubmit()
      })


    }
  }
}
</script>
<style scoped>

</style>
